import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import ServiceBanner from "../Components/ServiceBanner";
import Footer from "../Components/Footer";
import ServiceBar from "../Components/ServiceBar";
import customBanner from "../Images/auto.jpg";

export default function About() {
  return (
    <>
      <div className="fadeIn animated">
        <ServiceBanner
          customImage={customBanner}
        />

        <Row className="no-gutters mt-4 ">
          <Container>
            <Row>
              <Col sm={12} className="text-center ">
              <h3>ADVANCED DRIVER ASSISTANCE SYSTEMS </h3>
                <blockquote className="mt-4 font-italic">
                  <sup>
                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                  </sup>{" "}
                 We contribute to the development of safety and automation features in the automotive sector through our work in ADAS technologies. From lane detection and object recognition to collision avoidance and adaptive cruise control, we engineer systems using sensor fusion (camera, radar, LiDAR) and AI-driven algorithms. Our goal is to make driving safer, smarter, and more autonomous.{" "}
                  <sup>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>
                  </sup>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </Row>

       <section className="py-5 bg-light">
         <Container>
           <Row className="text-center">
             {/* Feature 1 */}
             <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
               <i className="bi bi-box fa-3x mb-3 text-primary"></i>
               <hr className="my-3" />
              <h5>Lane Detection & Assistance</h5>
               <div className="btSubTitle small">
                 Warns or assists the driver when the vehicle drifts out of its lane.
               </div>
              
             </Col>
       
             {/* Feature 2 */}
             <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
               <i className="bi bi-robot fa-3x mb-3 text-success"></i>
               <hr className="my-3" />
               <h5>Collision Avoidance</h5>
               <div className="btSubTitle small">
                 Detects potential collisions and automatically applies brakes if necessary.
               </div>
             
             </Col>
       
             {/* Feature 3 */}
             <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
               <i className="bi bi-car-front fa-3x mb-3 text-danger"></i>
               <hr className="my-3" />
               <h5>Object & Pedestrian Recognition</h5>
               <div className="btSubTitle small">
                Uses computer vision to detect vehicles, pedestrians, and obstacles in real time.
               </div>
               
             </Col>
           </Row>
           <br />
           <Row className="text-center">
             {/* Feature 1 */}
             <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
               <i class="bi bi-arrows-fullscreen fa-3x mb-3 text-warning"></i>
               <hr className="my-3" />
               <h5>Sensor Fusion</h5>
               <div className="btSubTitle small">
                Combines camera, radar, and LiDAR data for precise environment mapping and decision making.
               </div>
             
             </Col>
       
             {/* Feature 2 */}
             <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
               <i className="bi bi-backpack2 fa-3x mb-3 text-secondary"></i>
               <hr className="my-3" />
               <h5>Adaptive Cruise Control</h5>
               <div className="btSubTitle small">
              Automatically adjusts speed to maintain a safe following distance.
               </div>
              
             </Col>
       
             
           </Row>
         </Container>
       </section>

        <ServiceBar />
        <Footer />
      </div>
    </>
  );
}
